import {
  container,
  defaultFont,
  primaryColor,
  defaultBoxShadow,
  infoColor,
  successColor,
  warningColor,
  dangerColor
} from '../material-ui';

const headerStyle = theme => ({
  appBar: {
    // backgroundColor: '#0f0d36',
    boxShadow: 'none',
    borderBottom: '0',
    marginBottom: '0',
    // position: 'absolute',
    position: 'fixed',
    width: '100%',

    zIndex: '1',

    border: '0',

    padding: '0 0',
    transition: 'all 150ms ease 0s',
    minHeight: '40px',
    display: 'block',
    fontFamily:
      'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, "Noto Sans", "Apple Color Emoji", "Segoe UI Emoji"'
    // left: '20rem'
  },
  logoContainer: {
    display: 'flex',
    alignItems: 'center',
    '& img': {
      width: '36px',
      height: '36px',
      marginRight: '8px'
    }
  },
  navTitle: {
    paddingLeft: '10px',
    fontVariant: 'all-petite-caps'
  },
  navTitleHeaderContainer: {
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)'
  },
  navTitleHeader: {
    fontVariant: 'all-petite-caps',
    fontSize: '30px',
    fontWeight: 'bold',
    color: theme.palette.type === 'light' && 'white'
  },
  menuButtonPage: {
    cursor: 'pointer'
  },
  container: {
    ...container,
    minHeight: '40px'
  },
  flex: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    position: 'relative',
    alignItems: 'center'
  },
  rightFlexContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end'
  },
  menuButton: {
    margin: theme.spacing(1)
  },
  menuButtonRightPerson: {
    marginLeft: 'auto',
    backgroundColor: '#e6ecff',
    color: '#4294ff',
    '& svg': {
      width: '30px',
      height: '30px'
    },
    '&:hover': {
      backgroundColor: '#e6ecff',
      color: '#4294ff'
    }
    // marginRight: 20
  },
  menuButtonRight: {
    marginLeft: 'auto',
    marginRight: 12
  },
  title: {
    ...defaultFont,
    lineHeight: '30px',
    fontSize: '16px',
    borderRadius: '3px',
    textTransform: 'none',
    color: 'inherit',
    margin: '0',
    '&:hover,&:focus': {
      background: 'transparent'
    }
  },
  paygosLogoImage: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    width: '70px',
    height: '100%',
    marginRight: '125px',
    '& img': {
      width: '135px',
      background: 'white',
      padding: 8,
      marginLeft: '20px'
    }
  },
  itStrategyLogoImage: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    width: '70px',
    marginRight: '80px',
    '& img': {
      width: '130px',
      marginLeft: '12px'
    }
  },
  logoImage: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    width: '70px',
    height: '100%',
    marginRight: '60px',
    '& img': {
      width: '90px',
      marginLeft: '12px'
    }
  },
  appResponsive: {
    top: '8px'
  },
  dark: {
    backgroundColor: primaryColor,
    color: '#FFFFFF',
    ...defaultBoxShadow
  },
  primary: {
    backgroundColor: primaryColor,
    color: '#FFFFFF',
    ...defaultBoxShadow
  },
  info: {
    backgroundColor: infoColor,
    color: '#FFFFFF',
    ...defaultBoxShadow
  },
  success: {
    backgroundColor: successColor,
    color: '#FFFFFF',
    ...defaultBoxShadow
  },
  warning: {
    backgroundColor: warningColor,
    color: '#FFFFFF',
    ...defaultBoxShadow
  },
  danger: {
    backgroundColor: dangerColor,
    color: '#FFFFFF',
    ...defaultBoxShadow
  },
  // Centered nav button group container
  navButtonsContainer: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  // Shadcn-like small button styling for header
  navButton: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '32px',
    padding: '0 10px',
    borderRadius: '6px',
    fontSize: '12px',
    lineHeight: 1,
    color: '#ffffff',
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',
    transition: 'opacity 150ms ease',
    textDecoration: 'none',
    whiteSpace: 'nowrap',
    '&:hover': {},
    '& svg': {
      width: '16px',
      height: '16px',
      marginRight: '6px'
    }
  },
  navButtonActive: {
    backgroundColor: '#454275',
    fontWeight: 600
  }
});

export default headerStyle;
